module.exports = __webpack_public_path__ + "static/media/Pending.a6d4ceba.svg";